import React from 'react';
import {useField} from 'formik';
import RadioButtons, {Props as RadioButtonsProps} from 'shared/components/radio-buttons';

/**
  For use in Formik forms.

  Usage example:
  <FormikRadioButtons name="otherOptions" options={OTHER_OPTIONS} />
*/

const FormikRadioButtons = (props: {name: string} & RadioButtonsProps) => {
  const [field, meta] = useField(props.name);
  return (
    <RadioButtons
      {...props}
      {...field}
      error={meta.touched ? meta.error : ''}
      {...(props.onChange && {
        onChange: (e) => {
          field.onChange(e);
          props.onChange?.(e);
        },
      })}
    />
  );
};

export default FormikRadioButtons;
